export default __webpack_public_path__ + "static/public_preposition_02_720p-8b440cb0c1459805b37ff0ae74903d8e.mp4";